import {
  subscribeUnreadMessageCount,
  unsubscribeUnreadMessageCount,
  subscribePlatformMessages,
  unsubscribePlatformMessages,
  platformMessageMarkAsRead
} from './Actions';

export const messageActions = {
  subscribeUnreadMessageCount,
  unsubscribeUnreadMessageCount,
  subscribePlatformMessages,
  unsubscribePlatformMessages,
  platformMessageMarkAsRead
};
export { MESSAGE_API_NAMES } from './Actions';
export * from './Store';
export * from './hooks';
